import { DatePipe } from '@angular/common';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NzDatePickerComponent } from 'ng-zorro-antd/date-picker';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { taskSubtaskMaster } from 'src/app/Models/BasicForms/taskSubtaskMaster';
import { ApiService } from 'src/app/Service/api.service';

@Component({
  selector: 'app-task-drawer',
  templateUrl: './task-drawer.component.html',
  styleUrls: ['./task-drawer.component.css'],
  providers: [DatePipe]
})
export class TaskDrawerComponent implements OnInit {
  @Input() drawerClose: Function;
  @Input() data: taskSubtaskMaster;
  @ViewChild('endDatePicker') endDatePicker: NzDatePickerComponent;

  constructor(public _apiService: ApiService, private notificationService: NzNotificationService, private datePipe: DatePipe) { }

  ngOnInit(): void {
    this.loadAllCategories();
    this.loadAllFeatures();
    this.loadAllAssignee();
    this.loadAllReporters();
    this.loadAllParentTasks();
    this.loadAllDependentTasks();
  }

  categoryList = [];
  loadAllCategories() {
    this._apiService.getAllCategories(0, 0, 'ID', 'desc', ' and IS_ACTIVE=1').subscribe(categoryData => {
      this.categoryList = categoryData['data'];

    }, err => {

    });
  }

  featureList = [];
  loadAllFeatures() {
    this._apiService.getAllFeatures(0, 0, 'ID', 'desc', '').subscribe(featureData => {
      this.featureList = featureData['data'];

    }, err => {

    });
  }

  parentTaskList = [];
  loadAllParentTasks() {
    this._apiService.getAllTaskSubtask(0, 0, 'ID', 'desc', '').subscribe(taskData => {
      this.parentTaskList = taskData['data'];

    }, err => {

    });
  }

  dependentTaskList = [];
  loadAllDependentTasks() {
    this._apiService.getAllTaskSubtask(0, 0, 'ID', 'desc', '').subscribe(taskData => {
      this.dependentTaskList = taskData['data'];

    }, err => {

    });
  }

  assigneeList = [];
  loadAllAssignee() {
    this._apiService.getAllUsers(0, 0, 'ID', 'desc', '').subscribe(userData => {
      this.assigneeList = userData['data'];

    }, err => {

    });
  }

  reporterList = [];
  loadAllReporters() {
    this._apiService.getAllUsers(0, 0, 'ID', 'desc', '').subscribe(userData => {
      this.reporterList = userData['data'];

    }, err => {

    });
  }

  close(taskSbtaskPage: NgForm) {
    this.drawerClose();
    this.reset(taskSbtaskPage);
  }

  handleStartOpenChange(open: boolean): void {
    if (!open) {
      this.endDatePicker.open();
    }
  }

  tags = [];
  showTags(tagStr) {
    if (tagStr != "") {
      this.tags = tagStr.split(',');
    }
  }

  inputVisible = false;
  inputValue = '';
  @ViewChild('inputElement', { static: false }) inputElement?: ElementRef;

  handleClose(removedTag: {}): void {
    this.tags = this.tags.filter(tag => tag !== removedTag);
  }

  sliceTagName(tag: string): string {
    const isLongTag = tag.length > 20;
    return isLongTag ? `${tag.slice(0, 20)}...` : tag;
  }

  showInput(): void {
    this.inputVisible = true;
    setTimeout(() => {
      this.inputElement?.nativeElement.focus();
    }, 10);
  }

  handleInputConfirm(): void {
    if (this.inputValue && this.tags.indexOf(this.inputValue) === -1) {
      this.tags = [...this.tags, this.inputValue];
    }
    this.inputValue = '';
    this.inputVisible = false;
  }

  reset(taskSbtaskPage: NgForm) {
    taskSbtaskPage.form.reset();
    this.data = new taskSubtaskMaster();
    this.tags = [];
  }

  isSpinning = false;
  logtext: string = "";

  save(addNew: boolean, taskSbtaskPage: NgForm): void {
    var isOk = true;

    if (this.data.TASK_CATEGORY_ID == undefined) {
      isOk = false;
      this.notificationService.error("Please Select Valid Category", "");
    }

    if (this.data.FEATURE_ID == undefined) {
      isOk = false;
      this.notificationService.error("Please Select Valid Feature", "");
    }

    if (this.data.PARENT_ID == undefined) {
      this.data.PARENT_ID = 0;
    }

    if (this.data.NAME != undefined) {
      if (this.data.NAME.trim() == '') {
        isOk = false;
        this.notificationService.error("Please Enter Valid Task/ Subtask Name", "");
      }
    } else {
      isOk = false;
      this.notificationService.error("Please Enter Valid Task/ Subtask Name", "");
    }

    // if(this.data.DESCRIPTION != undefined) {
    //   if(this.data.DESCRIPTION.trim()== '') {
    //     isOk = false;
    //     this.notificationService.error("Please Select Valid Description","");
    //   }
    // }else {
    //   isOk = false;
    //   this.notificationService.error("Please Select Valid Description","");
    // }

    // if(this.data.ESTIMATED_HOURS != undefined) {
    //   if(this.data.ESTIMATED_HOURS== null) {
    //     isOk = false;
    //     this.notificationService.error("Please Enter Estimated Hour(s)","");
    //   }
    // }else {
    //   isOk = false;
    //   this.notificationService.error("Please Enter Estimated Hour(s)","");
    // }

    // if(this.data.ESTIMATED_MINUTES != undefined) {
    //   if(this.data.ESTIMATED_MINUTES== null) {
    //     isOk = false;
    //     this.notificationService.error("Please Enter Estimated Minute(s)","");
    //   }
    // }else {
    //   isOk = false;
    //   this.notificationService.error("Please Enter Estimated Minute(s)","");
    // }

    // if(this.data.ESTIMATED_SECONDS != undefined) {
    //   if(this.data.ESTIMATED_SECONDS== null) {
    //     isOk = false;
    //     this.notificationService.error("Please Enter Estimated Second(s)","");
    //   }
    // }else {
    //   isOk = false;
    //   this.notificationService.error("Please Enter Estimated Second(s)","");
    // }

    // if(this.data.ASSIGNEE_ID == undefined) {
    //   isOk = false;
    //   this.notificationService.error("Please Select Valid Assignee Name","");
    // }

    // if(this.data.REPORTER_ID == undefined) {
    //   isOk = false;
    //   this.notificationService.error("Please Select Valid Reporter Name","");
    // }

    if (this.data.PRIORITY == undefined) {
      isOk = false;
      this.notificationService.error("Please Select Valid Priority", "");
    }

    // if(this.data.TIME_TRACKED != undefined) {
    //   if(this.data.TIME_TRACKED== null) {
    //     isOk = false;
    //     this.notificationService.error("Please Select Time Tracked","");
    //   }
    // }else {
    //   isOk = false;
    //   this.notificationService.error("Please Select Time Tracked","");
    // }

    if (this.data.STATUS == undefined) {
      isOk = false;
      this.notificationService.error("Please Select Valid Status", "");
    }

    // if(this.data.START_DATE != undefined) {
    //   if(this.data.START_DATE== null) {
    //     isOk = false;
    //     this.notificationService.error("Please Select Start Date","");
    //   }
    // }else {
    //   isOk = false;
    //   this.notificationService.error("Please Select Start Date","");
    // }

    // if(this.data.END_DATE != undefined) {
    //   if(this.data.END_DATE== null) {
    //     isOk = false;
    //     this.notificationService.error("Please Select End Date","");
    //   }
    // }else {
    //   isOk = false;
    //   this.notificationService.error("Please Select End Date","");
    // }

    // if(this.data.IS_CHILD == undefined) {
    //   isOk = false;
    //   this.notificationService.error("Please Select Is Child or Not","");
    // }

    // if(this.data.DEPENDENT_TASK_ID == undefined) {
    //   this.data.DEPENDENT_TASK_ID= 0;
    // }

    // if(this.data.IS_CHILD == true) {
    //   if(this.data.DEPENDENT_TASK_ID == 0) {
    //     isOk = false;
    //     this.notificationService.error("Please Select Valid Dependent Task","");
    //   }
    // }

    // if(this.data.UPDATED_DATETIME != undefined) {
    //   if(this.data.UPDATED_DATETIME== null) {
    //     isOk = false;
    //     this.notificationService.error("Please Select Updated Date","");
    //   }
    // }else {
    //   isOk = false;
    //   this.notificationService.error("Please Select Updated Date","");
    // }

    // if(this.data.PROGRESS != undefined) {
    //   if(this.data.PROGRESS== null) {
    //     isOk = false;
    //     this.notificationService.error("Please Enter Progress","");
    //   }
    // }else {
    //   isOk = false;
    //   this.notificationService.error("Please Enter Progress","");
    // }

    if (isOk) {
      this.isSpinning = true;

      this.data.START_DATE = this.datePipe.transform(this.data.START_DATE, "yyyy-MM-dd");
      this.data.END_DATE = this.datePipe.transform(this.data.END_DATE, "yyyy-MM-dd");

      this.data.UPDATED_DATETIME = new Date();
      this.data.UPDATED_DATETIME = this.datePipe.transform(this.data.UPDATED_DATETIME, "yyyy-MM-dd HH:mm") + ":00";

      this.data.TIME_TRACKED = new Date();
      this.data.TIME_TRACKED = this.datePipe.transform(this.data.TIME_TRACKED, "HH:mm") + ":00";

      this.data.TAGS = this.tags.toString();



      if (!this.data.ID) {
        this._apiService.createTaskSubtask(this.data).subscribe(successCode => {


          if (successCode['code'] == "200") {
            this.notificationService.success("Task Added Successfully", "");

            if (!addNew) {
              this.drawerClose();
              this.isSpinning = false;
              this.reset(taskSbtaskPage);

              this.logtext = 'Save & Close - Task Master form - SUCCESS - ' + JSON.stringify(this.data) + " KEYWORD [C - Task Master ]";
              this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
                if (successCode['code'] == "200") {

                }
                else {

                }
              });

            } else {
              this.data = new taskSubtaskMaster();

              this.logtext = 'Save & New - Task Master form - SUCCESS - ' + JSON.stringify(this.data) + " KEYWORD [C - Task Master ]";
              this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
                if (successCode['code'] == "200") {

                }
                else {

                }
              });
            }
            this.isSpinning = false;
            this.reset(taskSbtaskPage);

          } else {
            this.notificationService.error("Failed to Add Task", "");
            this.logtext = 'Save & Close - Task Master form - ERROR - ' + JSON.stringify(this.data) + " KEYWORD [C - Task Master ]";
            this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
              if (successCode['code'] == "200") {

              }
              else {

              }
            });
          }

        }, err => {


          if (err["ok"] == false) {
            this.notificationService.error("Server Not Found", "");
          }
        });

      } else {
        this._apiService.updateTaskSubtask(this.data).subscribe(successCode => {


          if (successCode['code'] == "200") {
            this.notificationService.success("Task Updated Successfully", "");
            this.logtext = 'Update & Close - Task Master form - SUCCESS - ' + JSON.stringify(this.data) + " KEYWORD [C - Task Master ]";
            this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
              if (successCode['code'] == "200") {

              }
              else {

              }
            });

            this.isSpinning = false;
            this.drawerClose();
            this.reset(taskSbtaskPage);

          } else {
            this.notificationService.error("Failed to Update Task", "");
            this.logtext = 'Update & Close - Task Master form - ERROR - ' + JSON.stringify(this.data) + " KEYWORD [C - Task Master ]";
            this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
              if (successCode['code'] == "200") {

              }
              else {

              }
            });
          }

        }, err => {


          if (err["ok"] == false) {
            this.notificationService.error("Server Not Found", "");
          }
        });
      }
    }
  }

  switchOnChange(value) {
    if (value == true) {

    } else {
      this.data.DEPENDENT_TASK_ID = 0;
    }
  }

  selectOnChange(value) {
    if (value != 0) {
      this.data.IS_CHILD = true;

    } else {
      this.data.IS_CHILD = false;
    }
  }
}
